import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import {withStyles} from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import PropTypes from "prop-types";
import axios from "axios";

import {config} from "../../../auth/auth";
import {CircularProgress} from "@material-ui/core";

const defaultToolbarStyles = {
  iconButton: {
  },
};
const host = process.env.REACT_APP_HOST

class CustomToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      open: false,
      channel: "APP_NOTIFICATION",
      subject: undefined,
      content: undefined,
    };
  }

  static propTypes = {
    refresh: PropTypes.func.isRequired
  };

  handleClick = () => {
    this.setState({open: true});
  }

  cancel = () => {
    this.setState({open: false});
  };

  create = () => {
    const { refresh } = this.props;
    if (this.state.isLoading)
      return;
    const body = {
      channel: this.state.channel,
      subject: this.state.subject,
      content: this.state.content
    }
    this.setState({isLoading: true})
    return axios.post(`${host}/messageTemplate`, body, config())
      .then((response) => {})
      .catch(e => alert(e))
      .finally(() => {
        this.setState({isLoading: false, open: false, subject: undefined, content: undefined});
        refresh();
      });
  };

  handleChannelChange = (e) => {
    this.setState({channel: e.target.value});
  };

  handleSubjectChange = (e) => {
    this.setState({subject: e.target.value});
  };

  handleContentChange = (e) => {
    this.setState({content: e.target.value});
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Tooltip title={"NEW"}>
          <IconButton className={classes.iconButton} onClick={this.handleClick}>
            <AddIcon className={classes.deleteIcon} />
          </IconButton>
        </Tooltip>
        <Dialog open={this.state.open} onClose={this.cancel} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Create Notification</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To create a new notification, please enter your subject and content here.
            </DialogContentText>
            <FormControl className={classes.formControl} fullWidth>
              <InputLabel htmlFor="max-width">Channel</InputLabel>
              <Select
                disabled={this.state.isLoading}
                value={this.state.channel}
                onChange={this.handleChannelChange}
                inputProps={{
                  name: 'Channel',
                  id: 'Channel',
                }}
              >
                {/*<MenuItem value="EMAIL">Email</MenuItem>
                <MenuItem value="SMS">SMS</MenuItem> */}
                <MenuItem value="APP_NOTIFICATION">Notification</MenuItem>
                <MenuItem value="SYSTEM_NOTIFICATION">System Notification</MenuItem>
              </Select>
            </FormControl>
            <TextField
              error={!this.state.subject}
              helperText={this.state.subject ? "" : "Required"}
              disabled={this.state.isLoading}
              autoFocus
              value={this.state.subject}
              margin="dense"
              id="subject"
              label="Subject"
              type="text"
              fullWidth
              onChange={this.handleSubjectChange}
            />
            <TextField
              error={!this.state.content}
              helperText={this.state.content ? "" : "Required"}
              disabled={this.state.isLoading}
              multiline
              value={this.state.content}
              rows="6"
              margin="dense"
              id="content"
              label="Content"
              type="text"
              fullWidth
              onChange={this.handleContentChange}
            />
          </DialogContent>
          <DialogActions>
              <React.Fragment>
                {this.state.isLoading ? <CircularProgress style={{width:20, height:20}}/> : ""}
                <Button
                  onClick={() => this.create()}
                  style={{color: "white", backgroundColor: "#36b9cc"}}
                  disabled={this.state.isLoading || !this.state.content || !this.state.subject}
                >
                  Create
                </Button>
                <Button
                  onClick={this.cancel}
                  color="primary"
                  disabled={this.state.isLoading}
                >
                  Cancel
                </Button>
              </React.Fragment>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }

}

export default withStyles(defaultToolbarStyles, { name: "CustomToolbar" })(CustomToolbar);
